export const FREE = 1;
export const PREMIUM = 2;
export const EXPIRED_PREMIUM = 3;
export const NEAR_ENDING_PREMIUM = 4;

export const STATE_NAMES={
  [FREE]: "استاندارد",
  [PREMIUM]: "حرفه‌ای",
  [NEAR_ENDING_PREMIUM]: "حرفه‌ای",
  [EXPIRED_PREMIUM]:"استاندارد",
};

export default {
  FREE: 1,
  PREMIUM: 2,
  EXPIRED_PREMIUM: 3,
  NEAR_ENDING_PREMIUM: 4
};

